export const setStorageCompanyId = (companyId: string) => {
  localStorage.setItem('companyId', companyId);
};

export const getStorageCompanyId = (): string | null => {
  return localStorage.getItem('companyId');
};

export const setStorageLegalEntityId = (legalEntityId: string) => {
  localStorage.setItem('legalEntityId', legalEntityId);
};

export const getStorageLegalEntityId = (): string | null => {
  return localStorage.getItem('legalEntityId');
};

// make sure company id is exist in user's companies
export function setupCompanyId(currentUser: API.User) {
  if (!currentUser?.companies) {
    return;
  }
  const selectCompanyId = getStorageCompanyId();
  // not set company id in local storage
  if (!selectCompanyId) {
    const first = currentUser.companies[0];
    setStorageCompanyId(first?.id as string);
    if (first?.legalEntityId) {
      setStorageLegalEntityId(first.legalEntityId);
    }
  } else {
    // check if company id is not exist in user's companies
    const matched = currentUser.companies.find((company) => company.id === selectCompanyId);
    if (!matched) {
      const first = currentUser.companies[0];
      setStorageCompanyId(first?.id as string);
      if (first?.legalEntityId) {
        setStorageLegalEntityId(first.legalEntityId);
      }
    } else if (matched.legalEntityId) {
      // 同步 legalEntityId
      setStorageLegalEntityId(matched.legalEntityId);
    }
  }
}
